import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";

export default function Security() {
  return (
    <div>
      <Fixed />
      <div className="min-h-screen bg-white text-gray-900 pt-24">
        {/* Hero Section */}
        <div className="text-center py-16 px-6">
          <motion.h1
            className="text-5xl font-bold text-blue-600"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Security & Compliance
          </motion.h1>
          <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
            Ensuring top-notch security for your transactions, data, and smart systems with cutting-edge technology.
          </p>
        </div>

        {/* Security Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-16">
          <motion.div className="bg-gray-100 p-6 shadow-lg rounded-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}>
            <h2 className="text-xl font-semibold text-blue-600">Payment Security (JCSPay)</h2>
            <p className="mt-2 text-gray-700">End-to-end encryption, multi-factor authentication, and fraud detection ensure secure payments.</p>
          </motion.div>

          <motion.div className="bg-gray-100 p-6 shadow-lg rounded-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
            <h2 className="text-xl font-semibold text-blue-600">Smart Systems Security</h2>
            <p className="mt-2 text-gray-700">AI-driven security safeguards your IoT devices from unauthorized access.</p>
          </motion.div>

          <motion.div className="bg-gray-100 p-6 shadow-lg rounded-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}>
            <h2 className="text-xl font-semibold text-blue-600">Call Center Data Privacy</h2>
            <p className="mt-2 text-gray-700">We comply with GDPR regulations to protect customer conversations and data.</p>
          </motion.div>
        </div>

        {/* Compliance & Certifications */}
        <div className="mt-16 px-6 md:px-16 py-12 bg-blue-600 text-white text-center">
          <motion.h2
            className="text-3xl font-semibold"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Compliance & Certifications
          </motion.h2>
          <p className="mt-4 max-w-3xl mx-auto">
            We adhere to industry standards like PCI DSS for payments, GDPR for data privacy, and ISO 27001 for information security.
          </p>
        </div>

        {/* Contact Section */}
        <div className="text-center py-16 px-6">
          <motion.h2
            className="text-3xl font-semibold text-gray-800"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Report a Security Concern
          </motion.h2>
          <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
            If you notice any security issues, please contact us immediately at
            <span className="text-blue-600 font-medium"> tech.support@jcsglobal.in</span>.
          </p>
        </div>
      </div>
      <Footer1 />
    </div>
  );
}
